import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import useStore from '../store/useStore';
import { useFormData, useApiCall } from '../hooks';

const Login = () => {
  const navigate = useNavigate();
  const setAuth = useStore((state) => state.setAuth);

  // Use custom hooks
  const { values, handleChange } = useFormData({
    username: '',
    password: '',
  });
  const { isLoading, error, execute, clearError } = useApiCall();

  const handleLogin = async () => {
    const result = await execute(authAPI.login, values.username, values.password);

    if (result.success) {
      setAuth(result.data.user, result.data.token, result.data.companies || []);
      navigate('/');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading) {
      handleLogin();
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Kinspeed Wallboard</h2>

        {error && (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label htmlFor="username">Username or Email</label>
          <input
            type="text"
            id="username"
            name="username"
            value={values.username}
            onChange={(e) => {
              handleChange(e);
              clearError();
            }}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={values.password}
            onChange={(e) => {
              handleChange(e);
              clearError();
            }}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
          />
        </div>

        <button
          type="button"
          className="btn-primary"
          onClick={handleLogin}
          disabled={isLoading || !values.username || !values.password}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>

        <p style={{ marginTop: '1.5rem', textAlign: 'center', color: '#b0b0b0', fontSize: '0.9rem' }}>
          Contact your administrator for access
        </p>
      </div>
    </div>
  );
};

export default Login;
